/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React, { useMemo } from "react";
import Container from "../../../../components/Container/Container";
import Layout from "../../../Layouts/Layout";
import PartnerLogoSection from "../../../../components/Sections/Generic/PartnerLogoSection/PartnerLogoSection";
import LandingPageTeaser from "../../../../components/Teaser/LandingPageTeaser";
import AttorneySection from "../../../../components/Sections/Generic/AttorneySection/AttorneySection";
import DeathCheckin from "../../../../components/Checkin/FamilyLawCheckin/Death/DeathCheckin";
import LpDeathAragMeta from "./Arag/LpDeathAragMeta";
import LpDeathAdvoCardMeta from "./AdvoCard/LpDeathAdvoCardMeta";
import GreyBackgroundWrapper from "../../../../components/BackgroundWrapper/GreyBackgroundWrapper";
import LinkedCardBox from "../../../../components/LinkedCardBox/LinkedCardBox";
import { documentTeaserCards } from "../../../../services/landingPageService";
import { useCustomer } from "../../../../provider/Customer/CustomerProvider";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";
import HowItWorksSectionDeath from "../../../../components/Sections/FamilyLaw/Death/HowItWorksSection/HowItWorksSectionDeath";
import { PARTNER_IRIS } from "../../../../constants/partnerIris";

const getMetaDataByPartner = ({ partner }: { partner: string }) => {
  switch (partner) {
    case PARTNER_IRIS.ADVOCARD:
      return <LpDeathAdvoCardMeta />;
    case PARTNER_IRIS.ARAG:
      return <LpDeathAragMeta />;
    default:
      return null;
  }
};

const LpDeathPartner = ({ partner }: { partner: NonNullable<AbstractCase["acquisitionPartner"]> }) => {
  const { isLoggedIn } = useCustomer();
  const metaData = useMemo(() => getMetaDataByPartner({ partner }), [partner]);

  return (
    <Layout minimal={!isLoggedIn} clickableLogo={isLoggedIn} backgroundType={"landingpage"}>
      {metaData}
      <LandingPageTeaser
        headline={"Professionelle Hilfe bei Todesfall & Erbe"}
        subheadline={"Informationen erhalten und Gespräch vereinbaren"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={documentTeaserCards} />
      </LandingPageTeaser>
      <PartnerLogoSection partnerIri={partner} containerStyle={"settlementContainer"} />
      <GreyBackgroundWrapper>
        {!isLoggedIn && (
          <Container>
            <DeathCheckin idPrefix={"top"} partner={partner} />
          </Container>
        )}
        <HowItWorksSectionDeath />
      </GreyBackgroundWrapper>
      <AttorneySection
        textCards={false}
        subheading={"Sie möchten sich professionell und schnell unterstützen lassen? Wir helfen Ihnen - jederzeit und ortsunabhängig!"}
        heading={"Deutschlandweit tätige Partneranwälte"}
      />
      {!isLoggedIn && (
        <Container>
          <DeathCheckin idPrefix={"top"} partner={partner} />
        </Container>
      )}
    </Layout>
  );
};

export default LpDeathPartner;
